import React from 'react';
import { Modal, Box, Typography, Button, useMediaQuery, Autocomplete, TextField, IconButton } from '@mui/material';
import { useFormContext } from '../../contexts/CreateRecordFormContext';
import { Close } from '@mui/icons-material';

const OpportunityContactSelectModal = ({ open, handleClose, contacts, onSubmit }) => {
  const { formState, resetForm } = useFormContext();
  
  const isMobile = useMediaQuery('(max-width:600px)');
  const isLaptop = useMediaQuery('(max-width:1280px)')


  const handleFormSubmit = (e) => {
    e.preventDefault();
    onSubmit(formState); // Pass the form state when submitting
};

  // Call resetForm when closing the modal
  const handleModalClose = () => {
    resetForm();  // Reset the form state when the modal closes
    handleClose();
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? '85vw' : isLaptop ? '60vw' : '35vw',
    maxHeight: 650,
    overflow: "hidden",
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
  };
  
  const headerFooterStyle = {
    position: 'sticky',
    zIndex: 1,
    backgroundColor: 'background.paper',
  };

  return (
    <Modal open={open} onClose={handleModalClose}>
      <form onSubmit={handleFormSubmit}>
      <Box sx={modalStyle}>
        {/* Sticky Header */}
        <Box
          sx={{
            ...headerFooterStyle,
            top: 0,
            p: 2,
            borderBottom: '1px solid #ccc',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography variant="h6">Find Existing Contact</Typography>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </Box>
        {/* Scrollable Content */}
        <Box sx={{ overflowY: 'auto', flexGrow: 1, p: 2 }}>
            <Autocomplete
                sx={{marginTop: "1em", marginBottom: "1em"}}
                options={contacts}
                // onChange={}
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                )}
            />

        </Box>

        {/* Sticky Footer */}
        <Box sx={{ ...headerFooterStyle, bottom: 0, p: 2, borderTop: '1px solid #ccc', display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button type="submit" variant="contained" color="primary" sx={{ marginTop: "1em" }}>
            Assign Contact
          </Button>
        </Box>
      </Box>
      </form>
    </Modal>
  );

};

export default OpportunityContactSelectModal;
